export default "__VITE_ASSET__0fcec3e8__"